import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Box, TextField, Grid, MenuItem } from '@mui/material';

const employmentTypes = [
  { value: 'Full time', label: 'Full time' },
  { value: 'Part time', label: 'Part time' },
  { value: 'Casual', label: 'Casual' }
];

const payPeriods = [
  { value: 'All', label: 'All' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Fortnightly', label: 'Fortnightly' },
  { value: 'Monthly', label: 'Monthly' }
];

const jobTitles = [
  { value: 'Support worker', label: 'Support worker' },
  { value: 'Manager', label: 'Manager' },
  { value: 'Office support', label: 'Office support' },
  { value: 'Coordinator', label: 'Coordinator' }
];

const EmploymentTab = () => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Controller
            name="employment.jobTitle"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                select
                label="Job title"
                size="small"
                error={!!(errors.employment as any)?.jobTitle}
                helperText={(errors.employment as any)?.jobTitle?.message || ''}
                fullWidth
                margin="dense"
              >
                {jobTitles.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="employment.startDate"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Start date"
                type="date"
                InputLabelProps={{ shrink: true }}
                size="small"
                error={!!(errors.employment as any)?.startDate}
                helperText={(errors.employment as any)?.startDate?.message || ''}
                fullWidth
                margin="dense"
                value={field.value || ''} // Ensure string or empty string
                onChange={(e) => field.onChange(e.target.value)} // Pass string value
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="employment.employmentType"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                select
                label="Employment type"
                size="small"
                error={!!(errors.employment as any)?.employmentType}
                helperText={(errors.employment as any)?.employmentType?.message || ''}
                fullWidth
                margin="dense"
              >
                {employmentTypes.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="employment.weeklyWorkHours"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Weekly work hours"
                size="small"
                type="number"
                error={!!(errors.employment as any)?.weeklyWorkHours}
                helperText={(errors.employment as any)?.weeklyWorkHours?.message || ''}
                fullWidth
                margin="dense"
                InputProps={{
                  endAdornment: <span style={{ marginLeft: 4 }}>h</span>
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="employment.payPeriod"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                select
                label="Pay period"
                size="small"
                error={!!(errors.employment as any)?.payPeriod}
                helperText={(errors.employment as any)?.payPeriod?.message || ''}
                fullWidth
                margin="dense"
              >
                {payPeriods.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="employment.leaveLoading"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Leave loading"
                size="small"
                type="number"
                error={!!(errors.employment as any)?.leaveLoading}
                helperText={(errors.employment as any)?.leaveLoading?.message || ''}
                fullWidth
                margin="dense"
                InputProps={{
                  endAdornment: <span style={{ marginLeft: 4 }}>%</span>
                }}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmploymentTab;
